import { type FC } from "react";

import { AddIcon } from "@moment/icons";

import { Button } from "../../Button";
import { type BaseViewHandle } from "../BaseViewHandle";
import { ColumnItem } from "./ColumnItem";

const ColumnsPopoverContent: FC<{
	viewHandle: BaseViewHandle;
	toggleEditColumnPopover: (columnIndex: number) => void;
}> = ({ viewHandle, toggleEditColumnPopover }) => {
	return (
		<>
			<div className="text-sm font-bold -mx-4 px-6 pb-2 -mt-1">Columns</div>
			<div className="flex flex-col gap-2 -mb-4 -mx-4 pr-4 pt-2 pb-4 max-h-72 overflow-y-auto">
				{viewHandle.columns.allColumns.length === 0 ? (
					<div className="text-secondary italic ml-6 mb-2">No visible columns.</div>
				) : (
					viewHandle.columns.allColumns.map((column) => {
						const columnDef = column.columnDef;
						return (
							<ColumnItem
								key={columnDef.name}
								viewHandle={viewHandle}
								column={column}
								openEditColumnPopover={() =>
									toggleEditColumnPopover(
										viewHandle.columns.allColumns.findIndex(
											(c) => c.columnDef.name === columnDef.name
										)
									)
								}
							/>
						);
					})
				)}
				<div className="ml-4 mt-2">
					<Button
						preset="secondary"
						size="sm"
						className="!px-1.5"
						startIcon={<AddIcon />}
						onClick={() => viewHandle.appendColumn()}
					>
						Add Column
					</Button>
				</div>
			</div>
		</>
	);
};

export default ColumnsPopoverContent;
